import { render } from "./LaporanPenyataPemungut3.vue?vue&type=template&id=567aee54"
import script from "./LaporanPenyataPemungut3.vue?vue&type=script&lang=js"
export * from "./LaporanPenyataPemungut3.vue?vue&type=script&lang=js"

import "./LaporanPenyataPemungut3.vue?vue&type=style&index=0&id=567aee54&lang=css"
import "./LaporanPenyataPemungut3.vue?vue&type=style&index=1&id=567aee54&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__